import { render } from "./PaymentList.vue?vue&type=template&id=4667ff3b&scoped=true"
import script from "./PaymentList.vue?vue&type=script&lang=js"
export * from "./PaymentList.vue?vue&type=script&lang=js"

import "./PaymentList.vue?vue&type=style&index=0&id=4667ff3b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4667ff3b"]])

export default __exports__